import { render, staticRenderFns } from "./current_invitations.vue?vue&type=template&id=6e7043ba&scoped=true"
import script from "./current_invitations.vue?vue&type=script&lang=js"
export * from "./current_invitations.vue?vue&type=script&lang=js"
import style0 from "./current_invitations.vue?vue&type=style&index=0&id=6e7043ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7043ba",
  null
  
)

export default component.exports